import styled from 'styled-components';
import { cookieYellow1 } from '@ui-components/design-tokens';

export const StyledContainer = styled.div`
    text-align: center;
    justify-content: center;
`;

export const StyledSvg = styled.svg`
    width: 90px;
    margin-bottom: 20px;

    circle,
    path {
        fill: transparent;
        stroke: ${cookieYellow1};
        stroke-width: 10px;
        stroke-dasharray: 1;
        stroke-dashoffset: 1;
        stroke-linecap: round;
        stroke-linejoin: round;
        visibility: hidden;
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
    }

    circle {
        transform-origin: 100px 100px;
        transform: rotate(-90deg);
    }
`;
